import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=0ab6b653&scoped=true&"
import script from "./Divider.vue?vue&type=script&lang=ts&"
export * from "./Divider.vue?vue&type=script&lang=ts&"
import style0 from "./Divider.vue?vue&type=style&index=0&id=0ab6b653&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab6b653",
  null
  
)

export default component.exports